/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const signedUploadDataSchema = z.object({
	id: z.string(),
	url: z.string(),
	objectPath: z.string(),
	expiresAt: z.iso.datetime(),
	requiredHeaders: z.record(z.string(), z.string()),
})

export type SignedUploadDataSchema = z.infer<typeof signedUploadDataSchema>
